export default class Main {

	constructor() {
		this.init();
	}

	initHeroSlider() {

		$('.hero--slider').on('init', function() {
			$('.hero--slider--nav--item:first-child').addClass('active');
		});

		let heroSlider = $('.hero--slider').slick({
			arrows: false,
			//infinite: false,
			fade: true,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover: false,
		});

		heroSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			window.animateToIndex(nextSlide, () => {
				// console.log('onComplete', nextSlide);
			});
		});

		heroSlider.on('afterChange', function(event, slick, currentSlide) {
			$('.hero--slider--nav--item.active').removeClass('active');
			$('.hero--slider--nav--item[data-slide=' + (currentSlide + 1) + ']').addClass('active');
		});

		$('.hero--slider--nav--item').on('click', function(e) {
			heroSlider.slick('slickGoTo', parseInt(this.getAttribute('data-slide')) - 1);
		});
	}

	init() {

		// this.initHeroSlider();
		window.initHeroSlider = this.initHeroSlider;

		$('.menu--mobile--item').on('click', function(e) {
			if ($(this).hasClass('active')) {
				$(this).removeClass('active')
				$(this).next().hide(350)
				return
			}

			$('.menu--mobile--item.active').removeClass('active')
			$('.submenu--mobile').hide(350)

			$(this).addClass('active')
			$(this).next().show(350)
		})

		$('.burger-icon').on('click', function() {
			if ($('body').hasClass('menu-open')) {
				$('body').toggleClass('menu-open');
				$('.burger-icon').toggleClass('is-active');
				setTimeout(function() {
					$('.menu--mobile').toggleClass('flexed');
				}, 300)
			}
			else {
				$('.menu--mobile').toggleClass('flexed');
				setTimeout(function() {
					$('body').toggleClass('menu-open');
					$('.burger-icon').toggleClass('is-active');
				}, 300)
			}
		})

        $(window).on('click', function(event){
            event.stopPropagation()
            $('.d-open').removeClass('d-open')
            $('.dropdown-open').removeClass('dropdown-open')
        });

		$('.has--submenu').on('click', function(e) {
			$(this).parent().toggleClass('d-open');
			$('body').toggleClass('dropdown-open');
			e.stopPropagation();
		})

		$('.hero--filters--settore, .hero--filters--soluzione').on('click', function(e) {
			$('.d-open').removeClass('d-open');
			$(this).addClass('d-open');
			//$('body').toggleClass('dropdown-open');
			e.stopPropagation();
		})


		$('[data-scroll]').on('click', function(e) {
            var scroll = $($(this).attr('data-scroll')).offset().top
            
            scroll = scroll - $('header').height()

			$('html,body').animate({
				scrollTop: scroll
			}, 0);
		})

		$('[data-modal-open]').on('click', function(e) {
			let modal = $(this).attr('data-modal-open')
			$('body,html').addClass('modal-open');
			setTimeout(function() {
				$(modal).show(0);
			}, 250)
		})

		$('[data-modal-close]').on('click', function(e) {
			let modal = $(this).attr('data-modal-close')
			$(modal).hide(0);
			setTimeout(function() {
				$('body,html').removeClass('modal-open');
			}, 250)
		})

		let solutionSlider = $('.section--slider--slick').slick({
			centerMode: true,
			variableWidth: true,
			arrows: false,
			dots: true,
		})

		solutionSlider.on('afterChange', function(event, slick, currentSlide) {
			$('.section--slider--slick--nav .item.active').removeClass('active');
			$('.section--slider--slick--nav .item[data-slide=' + (currentSlide + 1) + ']').addClass('active');
		});

		$('.section--slider--slick--nav .item').on('click', function(e) {
			$('.section--slider--slick--nav .item.active').removeClass('active')
			$(this).addClass('active')
			solutionSlider.slick('slickGoTo', parseInt(this.getAttribute('data-slide')) - 1);
		});

		let genericSlider = $('.generic--slider .slides').slick({
			centerMode: true,
			variableWidth: true,
			arrows: false,
			dots: false,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						centerMode: false,
						variableWidth: false,
						arrows: false,
						dots: true
					}
				},
			]
		})

		$('.generic--slider .nav').on('click', function(e) {
			$(this).parent().find('.slides').slick(this.getAttribute('data-action'))
		})

		$(document).on('click', function(e) {
			$('.d-open').removeClass('d-open');
			$('.dropdown-open').removeClass('dropdown-open');
		})

		function scrollActions() {
			var st = window.pageYOffset || document.documentElement.scrollTop

			if (st > 1) {
				$('body').addClass('scrolling')
			}
			else {
				$('body').removeClass('scrolling')
			}
		}
		window.addEventListener('scroll', scrollActions, false)
		window.scrollTo(0, -1)
	}

}

const main = new Main();
